import {
  DataGrid,
  GridCallbackDetails,
  GridColDef,
  GridRowParams,
  GridSelectionModel,
} from '@mui/x-data-grid';
import Pagination from '@mui/material/Pagination';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { Grid, Typography } from '@mui/material';
import { useState } from 'react';

interface Props {
  columns: GridColDef[];
  data: any;
  isSelection?: boolean;
  onSelect?: (e: GridSelectionModel, x?: GridCallbackDetails) => void;
  onRowClick?: (e: any) => void;
  height?: string;
  isPagination?: boolean;
  disableSelectionOnClick?: boolean;
  fetchList?: any;
  loading?: boolean;
  isRowSelectable?: (params: GridRowParams<{ [key: string]: any }>) => boolean;
  showTotal?: boolean;
  total?: number
}

export default function DataTableClientSide(props: Props): JSX.Element {
  const { isPagination = true, disableSelectionOnClick = true, showTotal, total } = props;
  const [meta, setMeta] = useState<{ page: number, pageSize: number }>({ page: 0, pageSize: 10 })

  return (
    <div style={{ display: 'flex', height: props.height }}>
      <div style={{ flexGrow: 1 }}>
        <DataGrid
          rows={props.data?.dataList || props.data}
          autoHeight={!props.height}
          rowHeight={40}
          columns={props.columns}
          sortingMode="client"
          checkboxSelection={props.isSelection}
          isRowSelectable={props.isRowSelectable}
          disableSelectionOnClick={disableSelectionOnClick}
          onRowClick={props.onRowClick}
          onSelectionModelChange={props.onSelect}
          filterMode="client"
          loading={props.loading || props.data?.isLoading}
          pageSize={meta.pageSize}
          page={meta.page}
          components={{
            Footer: () =>
              isPagination ? (
                <Grid
                  container
                  alignItems="center"
                  justifyContent={showTotal ? 'space-between' : 'end'}
                  borderTop={'1px solid rgba(224, 224, 224, 1)'}
                  p={1}>
                  {showTotal && (
                    <Typography variant='inherit'>
                      Total: {total || props.data?.pagination?.count || 0}
                    </Typography>
                  )}
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    Rows per page:
                    <Select
                      size="small"
                      sx={{ mx: 1 }}
                      value={meta.pageSize}
                      onChange={(e) => setMeta({ page: 0, pageSize: Number(e.target.value) })}>
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={25}>25</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </Select>
                    <Pagination
                      sx={{ mt: [2, 0] }}
                      count={total ? Math.ceil(total / meta.pageSize) : props.data?.pagination?.lastPage}
                      page={meta.page + 1}
                      onChange={(e, val) => setMeta(prev => ({ ...prev, page: val - 1 }))}
                      variant="outlined"
                      color="primary"
                    />
                  </div>
                </Grid>
              ) : (
                <div></div>
              ),
          }}
        />
      </div>
    </div>
  );
}
